import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=5e8ea5c2&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style1 from "./Chat.vue?vue&type=style&index=1&id=5e8ea5c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8ea5c2",
  null
  
)

export default component.exports